<!-- 
  非访客计划详情页 - 跟进记录
  props:
    id: 详情id
 -->

<template>
	<div class="communicate-recorders">
        <div class="communicate">
        <div class="selecte-top" v-if="itemData.length">
            <el-form :rules="rules" :model="form" ref="ruleForm"  label-width="90px" class="menu">
                <el-form-item
                  v-for="(item, index) in itemData"
                  :label="item.attrName"
                  :prop="item.attr"
                  :key="item.attr"
                  class="opt-item"
                  :class="item.attr === 'contactArray' ? 'contactArray' : ''">
                  <!-- 无编辑权限 -->
                  <el-input
                    v-if="item.attrVisible"
                    value="* * * * * *"
                    :disabled="true">
                  </el-input>
                  <!-- 普通文本框 -->
                  <el-input
                    :disabled="item.nonEditable===1"
                    v-else-if="item.fieldType===1 || item.fieldType===7"
                    :placeholder="item.placeholder"
                    v-model="form[item.attr]">
                  </el-input>
                  <!-- 数字文本框 -->
                  <el-input
                    :disabled="item.nonEditable===1"
                    v-else-if="item.fieldType===2"
                    v-model.number="form[item.attr]"
                    @keyup.native="onInput(item)"
                    :placeholder="item.placeholder"
                    >
                    <template
                      v-if="item.unit"
                      slot="append">{{item.unit}}
                    </template>
                  </el-input>
                  <!-- 下拉选择框 自定义 -->
                  <el-select clearable
                    :disabled="item.nonEditable===1"
                    filterable
                    v-else-if="item.fieldType===3 && item.valueArrMap"
                    v-model="form[item.attr]"
                    :placeholder="item.placeholder"
                    >
                    <el-option
                      v-for="arr in item.valueArrMap"
                      :key="arr.key"
                      :label="arr.value"
                      :value="arr.key">
                    </el-option>
                  </el-select>
                  <!-- 下拉选择框 普通 -->
                  <el-select clearable
                    :disabled="item.nonEditable===1"
                    :placeholder="item.placeholder"
                    filterable
                    v-else-if="item.fieldType===3 && item.initValue"
                    v-model="form[item.attr]">
                      <el-option
                        v-for="(option, index) in strToArrItem(item.initValue)"
                        :key="index"
                        :value="option">
                      </el-option>
                  </el-select>
                  <!-- 日期选择 -->
                  <el-date-picker
                    :disabled="fuction(item)"
                    :editable="false"
                    v-else-if="item.fieldType===4"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期"
                    v-model="form[item.attr]"
                  >
                  </el-date-picker>
                  <!-- 多选框 -->
                  <el-checkbox-group
                    :disabled="item.nonEditable===1"
                    v-else-if="item.fieldType===9"
                    v-model="form[item.attr]">
                    <el-checkbox
                      v-for="(option, index) in strToArrItem(item.initValue)"
                      :label="option"
                      :key="index"
                      :name="item.attr">
                    </el-checkbox>
                  </el-checkbox-group>
                  <!-- 联系人 -->
                  <template v-else-if="item.attr === 'contactArray'">
                    <associated-field
                      ref="associatedField"
                      module="contactApi"
                      :multiselect="true"
                      :item="item"
                      :form="form"
                      :customerId="customerId"
                      @addNew="openAddnew"
                      @emitObj="saveObj"
                      >
                    </associated-field>
                  </template>
                  <!-- 跟进业务 -->
                  <template v-else-if="item.attr === 'communicateBusiness'">
                    <communicateBusiness 
                      :customerId="customerId"
                      :item="item"
                      :form="form"
                    ></communicateBusiness>
                  </template>
                  <!-- 拜访时间 -->
                  <template v-else-if="item.attr === 'communicateTime'">
                    <el-date-picker
                      :class="{disable: item && item.nonEditable}"
                      :editable="false"
                      v-model="form[item.attr]"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm"
                      value-format="yyyy-MM-dd HH:mm"
                      :picker-options="disableBefore"
                      placeholder="选择日期时间">
                    </el-date-picker>
                  </template>
              </el-form-item>
            </el-form>
        </div>
        <textarea
            placeholder="输入跟进记录..."
            class="enter"
            v-model="textareaValue">
        </textarea>
        <div class="options">
            <ul class="menu">
              <template v-for="(bottom, index) in bottomResult">
                <!-- 上传图片 -->
                <li class="opt-item" v-if="bottom.fieldType === 5" :key="bottom.fieldType">
                  <el-badge 
                  :hidden="images.length === 0"
                  :value="images.length" class="item">
                    <el-popover
                      placement="bottom-start"
                      title="上传图片"
                      width="400"
                      trigger="click">
                      <el-upload
                        class="img-box"
                        ref="imgUpload"
                        :action="uploadUlr"
                        :data="uploadData"
                        list-type="picture-card"
                        :accept="imgAccept"
                        :on-remove="imgRemove"
                        :on-error="handleError"
                        :on-success="imgAdd"
                        :file-list="uploadImg"
                        :before-upload="handleBeforeUpload"
                        >
                        <i class="el-icon-plus" @click="set_upload_param"></i>
                      </el-upload>
                        <i slot="reference" class="text web-icon-img"></i>
                    </el-popover>
                  </el-badge>
                </li>
                <li class="opt-item" v-else-if="bottom.fieldType === 8" :key="bottom.fieldType">
                  <el-badge 
                  :hidden="fileAttrValue.length === 0"
                  :value="fileAttrValue.length" class="item">
                    <el-popover
                      placement="bottom-start"
                      title="上传附件"
                      width="400"
                      trigger="click">
                      <el-upload
                        ref="fileUpload"
                        :action="uploadUlr"
                        :data="uploadData"
                        :on-remove="fileRemove"
                        :on-success="fileAdd"
                        :on-error="handleError"
                        :before-upload="handleBeforeUpload"
                        :file-list="uploadFile"
                        >
                        <el-button class="text" size="small" type="primary" @click="set_upload_param">添加附件</el-button>
                      </el-upload>
                      <i slot="reference" class="text web-icon-file"></i>
                    </el-popover>
                  </el-badge>
                </li>
              </template>
            </ul>
            <el-button size="small" type="primary" @click="handleSubmit" :disabled="disSubmit">提 交</el-button>
        </div>
        </div>
        <div class="item" v-for="(item, index) in refVisit" :key="item.opportunityId">
        <div class="item-content">
          <div class="user-infos">
            <div>
              <div class="title">
                <span class="name">{{item.userName}}</span>
                <span class="tag">{{item.commuicateTime}}</span>
              </div>

              <div class="avatar">
                  <img width="44" height="44" :src="item.avatar" :alt="item.userName">
              </div>
              <div class="others">
                  <span class="text">{{item.type}}</span>
                  <span class="text"> 
                    <a v-if="item.hideSupplier" href="javascript:;"  @click="unOpen">{{item.customerName}}</a>
                    <a v-else href="javascript:;"  @click="openDetail(item.customerId, openApi)">{{item.customerName}}</a>
                  </span>
              </div>
            </div>

            <div class="options">
              <span class="text" v-if="item.isEdit" @click="editItem(item.id)">编辑</span>
              <!-- <span class="text red" v-if="item.isDel" @click="handleDelete(item.id)">删除</span> -->
            </div>
          </div>

            <div class="article">
            <a href="javascript:;" @click="openDetail(item.opportunityId, 'opportunityApi')" class="talk" v-if="item.opportunityName">#{{item.opportunityName}}#</a>
            <p class="text" v-for="(p, i) in paragraph(item.memo)" :key="i">{{p}}</p>
            </div>

            <div class="gallery" v-if="item.images && item.images.length > 2">
              <ul class="gallery-wrap">
                  <li class="img" v-for="img in strToArr(item.images)" :key="img">
                  <img width="80" height="80" :src="img" @click="openLightbox(img)">
                  </li>
              </ul>
            </div>


            <div class="default">
              <p v-if="item.contactArray.length">联系人：
                <template v-if="['supplier', 'purchase'].indexOf(moduleName) > -1">
                  <span v-for="(contact, index) in item.contactArray" :key="contact.contactId">{{contact.contactName}}{{contact.position ? '('+ contact.position+')':''}}{{index !== item.contactArray.length-1?'、':''}}</span>
                </template>
                <template v-else>
                  <a v-for="(contact, index) in item.contactArray" :key="contact.contactId" @click="openDetail(contact.contactId, 'contactApi')">{{contact.contactName}}{{contact.position ? '('+ contact.position+')':''}}{{index !== item.contactArray.length-1?'、':''}}</a>
                </template>
              </p>
              <p v-if="item.communicateBusiness.id">{{item.communicateBusiness.type === 'salesOpportunity' ? '跟进机会' : '跟进合同'}}：<a @click="openDetail(item.communicateBusiness.id, item.communicateBusiness.type === 'salesOpportunity' ? 'opportunityApi' : 'contractApi')">{{item.communicateBusiness.value}}</a></p>
              <!-- <p>完成访客计划：<a ></a></p> -->
              <p v-if="item.address">位置：{{item.address}}</p>
            </div>

            
            <!-- 展开其他信息 -->
            <ul class="default" v-if="currentOpenIndex === index">
              <li class="render" v-for="other in item.redundantDetail" :key="other.attrName">
                  <span class="label">{{other.attrName}}：</span>
                  <template v-if="[5, 6].indexOf(other.fieldType) > -1">
                    <span class="img" v-for="(url, index) in strToArr(other.value4Show)" :key="index" @click="openLightbox(url)">
                      <img :src="url" height="40" width="40">
                    </span>
                  </template>
                  <template v-else-if="other.fieldType===8">
                    <!-- 附件信息 -->
                    <attachment-preview v-if="item.redundantDetail && item.redundantDetail.length" :data="fileData(item.redundantDetail)"></attachment-preview>
                  </template>
                  <template v-else-if="other.fieldType === 7">
                    <span class="text">
                        <p v-for="(p, i) in paragraph(other.value4Show)" :key="i">{{p}}</p>
                    </span>
                  </template>
                  <template v-else>
                  <span class="text">{{other.value4Show}}</span>
                  </template>
              </li>
            </ul>
        </div>
        <div class="item-options">
            <like :refId="item.id" v-if="item.like"></like>
            <a class="more" v-if="item.redundantDetail && item.redundantDetail.length" @click="redundantToggle(index)">{{currentOpenIndex === index ? '收起' : '更多'}}</a>
            <a
            href="javascript:;"
            class="option"
            :class="{'active': item.like}"
            @click="handleLike(item.id, index)"
            @mouseover="showLike(item.likeCount, index)"
            @mouseout="hideLike(item.likeCount, index)">
            <i class="icon" :class="[item.likeCount ? 'web-icon-thumbs-up' : 'web-icon-thumbs-up-o']"></i>
            <span class="text">点赞<em class="num" v-show="item.likeCount">({{item.likeCount}})</em></span>
            </a>
            <a href="javascript:;" class="option" :class="{'active': item.report}" @click="handleReport(index)">
            <i class="icon" :class="[item.commentCount ? 'web-icon-comment' : 'web-icon-comment-o']"></i>
            <span class="text">评论<em class="num" v-show="item.commentCount">({{item.commentCount}})</em></span>
            </a>
        </div>
        <report :refId="item.id" v-if="item.report"></report>
        </div>
        <div class="load-more">
        <template v-if="showLoadmore">
            <i class="el-icon-loading"></i>
            加载更多
        </template>
        <template v-if="!showLoadmore && page.total>page.size">没有更多</template>
        </div>

        <!-- 设置完成访客计划 -->
        <customer-plan
        v-if="planShow"
        :listData="planData"
        @close="planShow=false">
        </customer-plan>

        <!-- 新建 -->
        <add-new
        ref="addNew"
        :modal="false"
        v-if="addnewShow"
        @closeForDetail="addnewShow=false"
        @refresh="refreshForm"
        :addnewProp="addnewProp">
        </add-new>
	</div>
</template>

<script>
import Vue from 'vue'
import * as api from 'src/api'
import * as utils from 'src/utils'
import { mapGetters, mapActions } from 'vuex'
import { Message, MessageBox } from 'element-ui'
import Report from 'components/common/report'
import Like from 'components/common/like-list'
import lightBox from 'src/plugins/lightbox'
import customerPlan from 'components/modal/opportunity/customer-plan'
import communicateBusiness from 'components/modal/communicate-business'
import associatedField from 'components/fieldtype/associated-field'
import addNew from 'components/modal/add-new'
import { LS } from 'assets/js/storage'
import uploadMix from 'src/config/upload-mixin'
import attachmentPreview from 'components/common/attachment-preview'
let timer = null

// 自定义校验规则
const checkDate = (rule, value, callback) => {
  if (!value) {
    return callback(new Error())
  }
  callback()
}

const checkNumber = (rule, value, callback) => {
  if (value === '' && rule.required) {
    return callback(new Error(`请输入${rule.attrName}`))
  }
  // 小数位超出提示
  if (value.toString().indexOf('.') !== -1 && value.toString().split('.')[1].length > rule.num) {
    return callback(new Error(`该字段限制小数位数不能大于${rule.num}`))
  }
  if (value && isNaN(value)) {
    return callback(new Error('请输入正确的数字类型'))
  }
  callback()
}
export default {
  created () {
    this.getRefVisit()
    // 获取必填选项
    this.$nextTick(() => {
      this.getCheckRequire()
    })
    this.makeopUUID()

    // 读取草稿
    this.textareaValue = LS.get(`VUE-${this.moduleName}-communicate-draft`) || ''
  },
  beforeDestroy () {
    // 保存草稿
    LS.set(`VUE-${this.moduleName}-communicate-draft`, this.textareaValue)
  },
  props: {
    id: {
      type: Number
    },
    moduleName: {
      type: String
    },
    loading: {
      type: Number,
      default: 1
    },
    refresh: {
      type: Boolean
    },
    superBtn: {
      default: false
    }
  },
  data () {
    return {
      // 跟进记录绑定值
      textareaValue: '',
      form: {},
      itemData: [],
      rules: {},
      // 跟进记录
      refVisit: [],
      // 图片上传
      images: [],
      apiUrl: api.path,
      // 附件上传
      fileAttrValue: [],
      // 当前获取评论的id
      currentId: '',
      // 分页信息
      page: {
        size: 10,
        total: '',
        page: 1,
        rows: 1
      },
      load: false,
      // 完成访客计划相关
      planData: [],
      planShow: false,
      // 是否禁止提交
      disSubmit: false,
      opUUID: '',
      currentOpenIndex: '', // 当前展开的扩展字段序号
      addnewProp: {},
      addnewShow: false,
      disableBefore: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      bottomResult: [],
      customerId: ''
    }
  },
  mixins: [uploadMix],
  computed: {
    ...mapGetters([
      'getAttr'
    ]),
    // 字符串解析成对象
    refType () {
      return this.moduleName.replace('Api', '')
    },
    // 跟进记录进客户详情或供应商详情
    openApi () {
      if (this.moduleName === 'supplier' || this.moduleName === 'purchase') {
        return 'supplier'
      } else {
        return 'customerApi'
      }
    },
    // 是否显示加载更多
    showLoadmore () {
      if (this.page.total > this.page.size && this.page.rows > this.page.page) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions([
      'setAttr'
    ]),
    // 供应商无权限
    unOpen () {
      Message({
        type: 'error',
        message: '没有供应商字段的查看权限'
      })
      return
    },
    // 获取跟进记录
    getRefVisit () {
      clearTimeout(timer)
      timer = setTimeout(() => {
        const url = '/communicateApi/getRefVisit.html'
        const params = {
          refType: this.refType,
          refId: this.id,
          page: this.page.page,
          pageSize: this.page.size
        }
        api.post(url, params, (data) => {
          this.page.total = data.pageHelper.rowsCount
          this.page.rows = data.pageHelper.pageTotal
          data.result = data.result.map(item => {
            item.report = item.like = false
            return item
          })

          // 通过page.page来判断当前是刷新还是下拉加载更多
          if (this.page.page === 1) {
            this.refVisit = data.result
          } else {
            this.refVisit = this.refVisit.concat(data.result)
          }
        })
      }, 100)
    },
    // 加载更多
    loadmore () {
      this.page.page++
      this.getRefVisit()
    },
    // 解析JSON数组
    strToArr (str) {
      if (str instanceof Array) {
        return str
      }
      return window.utils.json(str)
    },
    fileData (arr) {
      let arrList
      arr.forEach(element => {
        if (element.fieldType === 8) {
          arrList = element.value4Show
        }
      })
      return arrList || ''
    },
    strToArrItem (str) {
      if (str) {
        return str.split('|')
      }
      return []
    },
    onInput (item) {
      var value = this.form[item.attr].toString()
      if (value.indexOf('.') !== -1) {
        var precisionLen = value.split('.')[1].length // 获取input输入小数位的长度
        if (precisionLen > item.decimalPrecision) {
          setTimeout(() => {
            // 如果小数位超出，则保留有效小数位
            this.form[item.attr] = value.substr(0, value.indexOf('.') + item.decimalPrecision + 1)
          }, 1500)
        }
      }
    },

    // 提交跟进记录
    handleSubmit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.textareaValue) {
            Message({
              type: 'error',
              message: '请输入跟进记录内容！'
            })
            return
          }
          if (this.images.length > 9) {
            Message({
              type: 'error',
              message: '图片最多上传9张'
            })
            return
          }
          if (this.fileAttrValue.length > 9) {
            Message({
              type: 'error',
              message: '文件最多上传9个'
            })
            return
          }
          this.sendData()
        } else {
          Message({
            type: 'error',
            message: '输入有误，请检查后重新提交！'
          })
          return false
        }
      })
    },
    // 格式化要提交的数据
    formatData () {
      let defaultData = {}
      let redundantData = {}
      this.itemData.forEach((item) => {
        // 如果是多选类型，先将数组转为字符串再保存
        if (item.fieldType === 9) {
          let value = this.form[item.attr]
          let formatCheckbox = value ? value.join('|') : value
          Vue.set(item.isRedundant ? redundantData : defaultData, item.attr, formatCheckbox)
        } else if (item.attr === 'communicateBusiness') {
          // 跟进记录的跟进业务处理
          let value = JSON.parse(JSON.stringify(this.form[item.attr]))
          Vue.set(item.isRedundant ? redundantData : defaultData, item.attr, {refType: value.key, refId: value.id})
        } else {
          Vue.set(item.isRedundant ? redundantData : defaultData, item.attr, (this.form[item.attr] !== undefined) ? this.form[item.attr] : '')
        }

      })
      this.bottomResult.forEach((item) => {
        Vue.set(item.isRedundant ? redundantData : defaultData, item.attr, item.fieldType === 5 ? this.handleImages() : this.fileAttrValue)
      })
      Vue.set(defaultData, 'memo', this.textareaValue)

      return {'defaultData': defaultData, 'redundantData': redundantData, 'opUUID': this.opUUID, refType: this.refType, refId: this.id}
    },
    handleImages () {
      let imgs = []
      this.images.map(item => {
        imgs.push(item.url + '?' + item.uid)
      })
      return imgs
    },
    sendData () {
      let url = '/communicateApi/save.html'
      let params = this.formatData()
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '操作成功'
        })
        // 清空已填写的数据，并重新获取所有跟进记录
        this.$refs.ruleForm.resetFields()
        this.itemData = []
        this.getCheckRequire()
        this.images = []
        this.fileAttrValue = []
        this.textareaValue = ''
        this.$refs.imgUpload && this.$refs.imgUpload[0].clearFiles()
        this.$refs.fileUpload && this.$refs.fileUpload[0].clearFiles()
        this.$emit('refresh') // 跟进记录更新，更新列表页

        LS.set(`VUE-${this.moduleName}-communicate-draft`, '')
        this.makeopUUID()
        this.getRefVisit()
        // 设置完成访客计划相关
        this.planData = data.plans || []
        if (this.planData.length) {
          this.planShow = true
        }
      })
      // 一秒钟之内，禁止多次重复提交
      this.disSubmit = true
      setTimeout(() => {
        this.disSubmit = false
      }, 1000)
    },
    // 回复
    handleReport (index) {
      this.refVisit[index].report = !this.refVisit[index].report
    },
    // 点赞
    handleLike (id, index) {
      const url = '/likeApi/save.html'
      const params = {
        refType: 'communicate',
        refId: id
      }
      api.post(url, params, (data) => {
        this.refVisit[index].likeCount += 1
      })
    },
    // 展示点赞者头像
    showLike (num, index) {
      if (num) {
        this.refVisit[index].like = true
      }
    },
    // 隐藏点赞者头像
    hideLike (num, index) {
      if (num) {
        this.refVisit[index].like = false
      }
    },
    // 将换行内容分割为数组
    paragraph (str) {
      if (str) {
        return str.split('\n')
      } else {
        return []
      }
    },
    openLightbox (url) {
      lightBox(url)
    },
    // 打开详情页
    openDetail (id, module) {
      this.$emit('openDetail', module, id)
    },
    // 移除图片
    imgRemove (file) {
      if (file) {
        this.images.forEach((item, index) => {
          if (item.uid === file.uid) {
            this.images.splice(index, 1)
          }
        })
      }
    },
    // 上传图片
    imgAdd (response, file) {
      this.images.push({url: this.fileUrl[file.uid], uid: file.uid, name: file.name})
    },
    getCheckRequire () {
      let url = '/communicateApi/getNewCheckRequire.html'
      let params = {
        type: this.refType,
        refId: this.id
      }
      api.post(url, params, (data) => {
        this.itemData = data.result
        this.bottomResult = data.bottomResult
        this.customerId = data.customerId
        // 设置初始值
        data.result.forEach((obj) => {
          if (obj.fieldType === 10) {
            Vue.set(this.form, obj.attr, Number(obj.attrValue))
          } else if (obj.fieldType === 2) {
            Vue.set(this.form, obj.attr, obj.attrValue === '' ? '' : Number(obj.attrValue))
          } else if (obj.fieldType === 4) {
            Vue.set(this.form, obj.attr, obj.attrValue || (!obj.isRedundant ? utils.formatDate() : ''))
          } else if (obj.fieldType === 9) {
            Vue.set(this.form, obj.attr, obj.attrValue ? obj.attrValue.split('|') : [])
          } else if ([5, 6, 8].indexOf(obj.fieldType) > -1) {
            if (!obj.attrValue) {
              obj.attrValue = '[]'
            }
            Vue.set(this.form, obj.attr, JSON.parse(obj.attrValue))
          } else if (obj.fieldType === 1501) {
            Vue.set(this.form, obj.attr, {id: '', value: false})
          } else {
            Vue.set(this.form, obj.attr, obj.attrValue)
          }

          // 特殊日期类型
          if (obj.attr === 'communicateTime') {
            Vue.set(this.form, obj.attr, obj.attrValue || utils.formatDate(new Date(), 'datetime'))
          }
        })

        data.result.forEach((obj) => {
          // 配置验证规则
          // 字符串
          if (obj.required && [1, 7].indexOf(obj.fieldType) > -1) {
            Vue.set(this.rules, obj.attr, { required: true, message: `请输入${obj.attrName}`, trigger: 'blur' })
          } else if (obj.fieldType === 0 && obj.required) {
            // 特殊字段
            Vue.set(this.rules, obj.attr, { required: true, type: obj.validate, message: `请选择${obj.attrName}`, trigger: 'change' })
            // 数字
          } else if (obj.fieldType === 2) {
            Vue.set(this.rules, obj.attr, { validator: checkNumber, required: !!obj.required, attrName: obj.attrName, num: obj.decimalPrecision, trigger: 'change' })
          } else if (obj.fieldType === 3) {
            Vue.set(this.rules, obj.attr, { required: !!obj.required, trigger: 'blur', message: `请选择${obj.attrName}` })
            // 日期
          } else if (obj.fieldType === 4 && obj.required) {
            Vue.set(this.rules, obj.attr, { validator: checkDate, required: true, message: `请选择${obj.attrName}`, trigger: 'change' })
            // 数组
          } else if ([5, 6, 8, 9].indexOf(obj.fieldType) > -1 && obj.required) {
            Vue.set(this.rules, obj.attr, { required: true, type: 'array', message: `请选择${obj.attrName}`, trigger: 'change' })
          } else if (obj.fieldType === 40 && obj.required) {
            Vue.set(this.rules, obj.attr, { required: true, type: obj.validate, message: `请选择${obj.attrName}` })
          } else if (obj.fieldType === 41 && obj.required) {
            Vue.set(this.rules, obj.attr, { required: true, type: obj.validate, message: `请选择${obj.attrName}` })
            // 其他类型
          } else if (obj.required && obj.fieldType !== 0) {
            Vue.set(this.rules, obj.attr, { required: true, message: `请选择${obj.attrName}`, trigger: 'change' })
          }
        })
      })
    },

    // 根据时间戳生成hash
    makeopUUID () {
      let d = new Date()
      this.opUUID = d.getTime()
    },
    // 编辑跟进记录
    editItem (id) {
      if (this.addnewShow) {
        this.addnewShow = false
        this.$nextTick(() => {
          this.editItem(id)
        })
        return
      }
      this.addnewProp = {
        id: id,
        module: 'communicateApi',
        type: 'communicateApi'
      }
      this.addnewShow = true
      this.$nextTick(() => {
        this.$refs.addNew.dialogFormVisible = true
      })
    },
    // 打开新建窗口
    openAddnew (obj) {
      this.addnewProp = {
        refId: this.id,
        module: 'communicateApi',
        type: this.moduleName
      }
      if (obj) {
        this.addnewProp = {
          refId: obj.refId,
          module: obj.module,
          type: obj.type
        }
        // 供应商新建联系人
        if (obj.supplierId) {
          this.addnewProp.supplierId = obj.supplierId
        }
      }
      this.addnewShow = true
      this.$nextTick(() => {
        this.$refs.addNew.dialogFormVisible = true
      })
    },

    saveObj (obj) {
      this.form.contactArray = obj
    },

    // 判断文件名或uid，有任意一个则视为相等
    fileRemove (file) {
      if (file) {
        let arr = this.fileAttrValue
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].attachIndex === file.url || arr[i].uid === file.uid) {
            arr.splice(i, 1)
          }
        }
      }
    },

    fileAdd (response, file) {
      let newFile = {
        filename: file.name,
        attachIndex: this.fileUrl[file.uid],
        ext: file.name.replace(/.+\./, '').toLowerCase(),
        size: file.size,
        uid: file.uid,
        name: file.name
      }
      this.fileAttrValue.push(newFile)
    },

    refreshForm () {
      if (this.$refs.associatedField) {
        if (this.$refs.associatedField.length) {
          for (let i = 0; i < this.$refs.associatedField.length; i++) {
            this.$refs.associatedField[i].refresh()
          }
        } else {
          this.$refs.associatedField.refresh()
        }
      }
      this.getRefVisit()
    },

    fuction (item) {
      if (this.addnewProp.id && this.moduleName === 'workReportApi' && item.attr === 'reportDate') {
        return true
      }
      return false
    },
    // 删除确认
    handleDelete (id) {
      MessageBox.confirm('确定删除该数据吗?', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteItem(id)
      }).catch(() => {})
    },
    // 删除
    deleteItem (id) {
      let url = `/communicateApi/delete.html`
      let params = {
        id: id
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: '删除成功!'
        })
        this.getRefVisit()
      })
    },

    // 展开or收起扩展字段信息
    redundantToggle (index) {
      if (this.currentOpenIndex === index) {
        this.currentOpenIndex = ''
      } else {
        this.currentOpenIndex = index
      }
    }
  },
  watch: {
    loading () {
      if (this.page.rows > this.page.page) {
        this.loadmore()
      }
    },
    // 是否重新获取跟进记录
    refresh () {
      this.getRefVisit()
    },

    // 监听异步验证字段
    getAttr (attr) {
      if (this.rules[attr]) {
        this.$refs.ruleForm.validateField(attr)
        this.setAttr('')
      }
    }
  },
  components: {
    Report,
    Like,
    customerPlan,
    addNew,
    communicateBusiness,
    associatedField,
    attachmentPreview
  }
}
</script>
<style lang="less">
  @import '../../assets/less/popover-upload-img.less';
</style>
<style lang="less" scoped>
  @import '../../assets/less/variable.less';
  .communicate-recorders {
    .default {
      .p {
        word-break: break-all;
      }
      .render {
        display: flex;
        .label {
          flex: 0 0 auto;
        }
      }
    }
    .communicate {
      position: relative;
      background:#ffffff;
      border:1px solid #e5ecf7;
      border-radius:2px;
      /deep/.el-date-editor {
        width: 100%;
      }
      .item-select {
        white-space: nowrap;
      }
      .is-error {
        .item-select {
          border: 1px solid #ff4949;
        }
      }
      .selecte-top {
        width: 100%;
        padding: 10px 12px 6px 12px;
        background: #F5F9FF;
        box-sizing: border-box;
        .menu {
          display: flex;
          flex-wrap: wrap;
          .opt-item {
            width: 47%;
            margin-right: 12px;
            margin-bottom: 20px;
            box-sizing: border-box;
          }
          .el-form-item {
            margin-bottom: 20px;
          }
          .contactArray {
            &.el-form-item {
              overflow: hidden;
            }
          }
        }
      }
      .enter {
        box-sizing: border-box;
        width: 100%;
        resize: none;
        border: none;
        padding: 8px;
        height: 126px;
        line-height: 22px;
        font-size: 13px;
        font-family: 'microsoft Yahei';
        color: #444;
      }
      .options {
        position: relative;
        background:#f5f9ff;
        height:40px;
        .menu {
          padding: 13px 0 0 18px;
          /deep/.el-badge__content {
            background-color:#6a82a4;
            height: 14px;
            line-height: 14px;
            padding: 0px 4px;
            font-size: 10px;
          }
          .opt-item {
            display: inline-block;
            font-size: 13px;
            padding-right: 48px;
            &:first-child {
              padding-top: 1px;
              padding-bottom: 1px;
            }
            &:last-child {
              border-right-width: 0;
            }
            &.required::after {
              content: "*";
              position: absolute;
              color: red;
              left: 10px;
              top: 2px;
            }
            .text {
              word-break: break-all;
              cursor: pointer;
              color: #C4D1EB;
              font-size: 16px;
            }
          }
        }
        .el-button {
          position: absolute;
          top: 7px;
          right: 10px;
          padding: 6px 15px;
        }
      }
    }
    &>.item {
      position: relative;
      background:#ffffff;
      border:1px solid #e5ecf7;
      border-radius:2px;
      margin-top: 16px;
      .item-content {
        .default {
          padding: 15px 15px 0;
          font-size: 14px;
          line-height: 1.6;
          text-align: justify;
        }
        .user-infos {
          position: relative;
          padding: 15px 15px 0 70px;
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          .title {
            line-height: 1.4;
            font-size: 0;
            .name {
              font-size: 14px;
            }
            .tag {
              font-size: 13px;
              color: @light-blue;
              margin-left: 10px;
            }
          }
          .avatar {
            position: absolute;
            width: 44px;
            height: 44px;
            left: 15px;
            top: 15px;
            img {
              display: block;
            }
          }
          .others {
            display: block;
            padding: 10px 0 2px;
            .text {
              display: inline-block;
              line-height: 1;
              font-size: 13px;
              color: @light-gray;
              border-right: 1px solid @light-gray;
              padding-right: 12px;
              margin-right: 12px;
              &:last-child {
                margin-right: 0;
                border-right-width: 0;
                padding-right: 0;
              }
            }
          }
          .options {
            .text {
              position: relative;
              display: inline-block;
              font-size: 13px;
              line-height: 1;
              color: @primary;
              padding-right: 14px;
              border-right: 1px solid @light-blue;
              margin-right: 10px;
              cursor: pointer;
              &:last-child {
                margin-right: 0;
                border-right-width: 0;
                padding-right: 0;
              }
              &.red {
                color: @bg-red;
              }
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
        .gallery {
          margin: 20px 15px 0;
          .gallery-wrap {
            font-size: 0;
            .img {
              width: 80px;
              height: 80px;
              margin-right: 19px;
              overflow: hidden;
              display: inline-block;
            }
          }
        }
        .article {
          padding: 20px 15px 0;
          font-size: 14px;
          line-height: 1.6;
          text-align: justify;
          word-break: break-all;
          .talk {
            color: @primary;
            margin-right: 4px;
          }
        }
        .desc {
          background:#ffffff;
          border:1px solid #e5ecf7;
          margin: 20px 15px 0;
          padding: 9px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          word-break: break-all;
          .text {
            display: inline-block;
            line-height: 1;
            font-size: 13px;
            color: @light-blue;
            border-right: 1px solid @light-blue;
            padding-right: 12px;
            margin-right: 12px;
            &:last-child {
              margin-right: 0;
              border-right-width: 0;
              padding-right: 0;
            }
          }
        }
        .other-desc {
          background-color: #f8f8f8;
          margin: 15px 15px 0;
          padding: 5px 10px;
          .o-d {
            padding: 5px 0;
            display: flex;
            font-size: 13px;
            
            .label {
              width: 100px;
              flex: 0 0 100px;
              color: #929292;
            }
            .img {
              img {
                height: 40px;
                display: inline-block;
              }
            }
          }
        }
      }
      .flex {
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
      }
      .item-options {
        position: relative;
        background-color: #f5f9ff;
        text-align: right;
        padding: 13px;
        .option {
          position: relative;
          display: inline-block;
          font-size: 13px;
          line-height: 1;
          color: @light-blue;
          padding-right: 12px;
          border-right: 1px solid @light-blue;
          margin-right: 12px;
          &:last-child {
            margin-right: 0;
            border-right-width: 0;
            padding-right: 0;
          }
          &:before {
            position: absolute;
            z-index: 2;
            content: '';
            width: 10px;
            height: 10px;
            top: 23px;
            left: 28px;
            background-color: #fff;
            box-shadow: 0 0 1px 1px #cdd9eb inset;
            transform: rotate(45deg);
            display: none;
          }
          &:after {
            position: absolute;
            z-index: 3;
            content: '';
            width: 12px;
            height: 7px;
            background-color: #fff;
            top: 28px;
            left: 27px;
            display: none;
          }
          &.active {
            &:before {
              display: block;
            }
            &:after {
              display: block;
            }
          }
          .icon {
            vertical-align: middle;
            font-size: 12px;
          }
          .text {
            margin-left: 2px;
            vertical-align: middle;
            display: inline-block;
            .num {
              font-style: normal;
            }
          }
        }
        .more {
          float: left;
          font-size: 13px;
          padding: 0 2px;
        }
      }
    }
  }
  .no-data {
    color: @light-gray;
    text-align: center;
  }
</style>
<style>
.item-content .file-content .render .file .operate {
  margin-left: 120px;
}
</style>

<style lang="less">
  .el-dropdown-menu {
    .el-checkbox-group {
      p {
        padding: 4px 10px;
      }
    }
  }
  .communicate-recorders {
    .menu {
      .el-checkbox__inner {
        z-index: 0;
      }
    }
    .opt-item {
      position: relative;
      .el-upload-list {
        z-index: 50;
        width: 230px;
        top: 28px;
        left: 0;
        border-radius: 2px;
        box-shadow:  0 0 4px 0 rgba(114, 114, 114, 0.5);
        position: absolute;
        background-color: #fff;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// communicate-record-new.vue?92465e36